// extracted by mini-css-extract-plugin
module.exports = {"authBtn":"src-pages-business-components-AuthButton-__index__authBtn--3isnG","rzBtn":"src-pages-business-components-AuthButton-__index__rzBtn--2ogUU"};